import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [categories, setCategories] = useState([]);

  const refresh = () => {
    api.get("/settings").then((r) => setSettings(r.data || {})).catch(() => {});
    api.get("/categories?active_only=true").then((r) => setCategories(r.data || [])).catch(() => {});
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SiteContext.Provider value={{ settings, categories, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
